import axios from "axios";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
  // Dashboard Statistic
  getSalesCount({ dispatch, commit }) {
    axios
      .get("Admin/Dashboard/SalesCount")
      .then((res) => {
        commit("setSalesCount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSumSales({ dispatch, commit }) {
    axios
      .get("Admin/Dashboard/SumSales")
      .then((res) => {
        commit("setSumSales", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSalesCountInMonth({ dispatch, commit }) {
    axios
      .get("Admin/Dashboard/SalesCountInMonth")
      .then((res) => {
        commit("setSalesCountInMonth", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Visitors and website Statistic 
  getVisits({ dispatch, commit }) {
    axios
      .get("Admin/Statistic")
      .then((res) => {
        commit("setVisits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMostVisited({ dispatch, commit }) {
    axios
      .get("Admin/Statistic/MostVisited")
      .then((res) => {
        commit("setMostVisited", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMostVisitPerDay({ dispatch, commit }) {
    axios
      .get("Admin/Statistic/MostVisitDay")
      .then((res) => {
        commit("setMostVisitPerDay", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMostVisitPerHour({ dispatch, commit }) {
    axios
      .get("Admin/Statistic/MostVisitHour")
      .then((res) => {
        commit("setMostVisitPerHour", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMostVisitPerCountry({ dispatch, commit }) {
    axios
      .get("Admin/Statistic/MostVisitCountry")
      .then((res) => {
        commit("setMostVisitPerCountry", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getVisitorsList({ dispatch, commit }, data) {
    axios
      .get("Admin/Statistic/Get?" + data)
      .then((res) => {
        commit("setVisitorsList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ..................  Services ...................
  getServices({ dispatch, commit }) {
    axios
      .get("admin/Service")
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServicesById({ dispatch, commit }, data) {
    axios
      .get("admin/Service/" + data)
      .then((res) => {
        commit("setService", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Service", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/Service/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteService({ dispatch }, data) {
    axios
      .delete("admin/Service/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ..................  Tickets  ...................
  getTicketCategories({ dispatch, commit }) {
    axios
      .get("admin/TicketType")
      .then((res) => {
        commit("setTicketCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTicketCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/TicketType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTicketCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("admin/TicketType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTicketCategory({ dispatch }, data) {
    axios
      .delete("admin/TicketType/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getWaitingTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setWaitingTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAnsweredTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setAnsweredTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getClosedTickets({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket?" + data)
      .then((res) => {
        commit("setClosedTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTicket({ dispatch, commit }, data) {
    axios
      .get("admin/Ticket/" + data)
      .then((res) => {
        commit("setTicket", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTicketAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("admin/Ticket", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  closeMessage({ dispatch }, data) {
    axios
      .put("admin/Ticket/ChangeClosedStatus/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.done,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteMessage({ dispatch }, data) {
    axios
      .delete("admin/Ticket/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Brands Actions ------------------------------------------------------------------
  getBrands({ dispatch, commit }) {
    axios
      .get("admin/brand")
      .then((res) => {
        commit("setBrands", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBrand({ dispatch }, data) {
    axios
      .post("admin/brand", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  getBrandById({ dispatch, commit }, data) {
    axios
      .get("admin/Brand/" + data)
      .then((res) => {
        commit("setBrand", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editBrand({ dispatch }, data) {
    axios
      .put("admin/brand/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteBrand({ dispatch }, data) {
    axios
      .delete("admin/brand/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // FestivalDiscounts Actions -------------------------------------------------------------------------------
  getFestivalDiscounts({ dispatch, commit }, data) {
    axios
      .get(
        "Admin/FestivalDiscount?fromDateLocal=" +
        data.fromDateLocal +
        "&toDateLocal=" +
        data.toDateLocal
      )
      .then((res) => {
        commit("setFestivalDiscounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addFestivalDiscount({ dispatch }, data) {
    axios
      .post("Admin/FestivalDiscount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.submit, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editFestivalDiscount({ dispatch }, data) {
    axios
      .put("Admin/FestivalDiscount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.edit, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  deleteFestivalDiscount({ dispatch }, data) {
    axios
      .delete("Admin/FestivalDiscount/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.delete, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Product Category Actions ------------------------------------------------------------------
  getProductCategoryChilds({ dispatch, commit }) {
    axios
      .get("admin/category/Childs?groupId=2")
      .then((res) => {
        commit("setProductCategoryChilds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Product Features Actions ------------------------------------------------------------------
  getProductFeatures({ dispatch, commit }) {
    axios
      .get("admin/Feature")
      .then((res) => {
        commit("setProductFeatures", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductFeatureDetailsByFeatureId({ dispatch, commit }, data) {
    axios
      .get("admin/FeatureDetail?featureId=" + data)
      .then((res) => {
        commit("setProductFeatureDetailsByFeatureId", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductFeaturesByCategory({ dispatch, commit }, data) {
    axios
      .get("admin/Category/LoadWithFeatures?categoryId=" + data)
      .then((res) => {
        commit("setProductFeaturesByCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProductFeature({ dispatch }, data) {
    axios
      .post("admin/feature", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editProductFeature({ dispatch }, data) {
    axios
      .put("admin/feature/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteProductFeature({ dispatch }, data) {
    axios
      .delete("admin/feature/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getProductFeatureDetails({ dispatch, commit }, data) {
    axios
      .get("admin/Feature/" + data)
      .then((res) => {
        commit("setProductFeatureDetails", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProductFeatureDetail({ dispatch }, data) {
    axios
      .post("admin/FeatureDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editProductFeatureDetail({ dispatch }, data) {
    axios
      .put("admin/FeatureDetail/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteProductFeatureDetail({ dispatch }, data) {
    axios
      .delete("admin/FeatureDetail/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Product Actions  ---------------------------------------------------------------
  getProducts({ dispatch, commit }, data) {
    axios
      .get("admin/Product?" + data)
      .then((res) => {
        commit("setProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProduct({ dispatch, commit }, data) {
    axios
      .get("admin/Product/" + data)
      .then((res) => {
        commit("setProduct", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProduct({ dispatch }, data) {
    axios
      .post("admin/Product", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: "ProductsList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editProduct({ dispatch }, data) {
    axios
      .put("admin/Product/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: "ProductsList",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteProduct({ dispatch }, data) {
    axios
      .delete("admin/Product/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Product Gallery Actions --------------------------------------------------------
  getProductImages({ dispatch, commit }, data) {
    axios
      .get("admin/ProductImage/" + data)
      .then((res) => {
        commit("setProductImages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProductImage({ dispatch }, data) {
    axios
      .post("admin/ProductImage", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  changeProductDefaultImage({ dispatch }, data) {
    axios
      .put("admin/ProductImage/changeDefaultImage", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteProductImage({ dispatch }, data) {
    axios
      .delete("admin/ProductImage/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Out Of Stock Actions ------------------------------------------------------------------
  getOutOfStocks({ dispatch, commit }) {
    axios
      .get("admin/outOfStock")
      .then((res) => {
        commit("setOutOfStocks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addOutOfStock({ dispatch }, data) {
    axios
      .post("admin/outOfStock", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editOutOfStock({ dispatch }, data) {
    axios
      .put("admin/outOfStock/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteOutOfStock({ dispatch }, data) {
    axios
      .delete("admin/outOfStock/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Returns Actions -------------------------------------------------------------------------------
  getReturns({ dispatch, commit }) {
    axios
      .get("admin/Return?status=0")
      .then((res) => {
        commit("setNewReturns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCheckedReturns({ dispatch, commit }) {
    axios
      .get("admin/Return?status[0]=1&status[1]=-1")
      .then((res) => {
        commit("setCheckedReturns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  editChangeStatus({ dispatch }, data) {
    axios
      .put("admin/Return/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.submit, redirect: false },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getFactorByID({ dispatch, commit }, data) {
    axios
      .get("admin/Factor/" + data)
      .then((res) => {
        commit("setFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // ContactMessages Actions -------------------------------------------------------------------------------
  getContactMessages({ dispatch, commit }) {
    axios
      .get("Admin/ContactUs")
      .then((res) => {
        commit("setContactMessages", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  deleteContactMessage({ dispatch }, data) {
    axios
      .delete("Admin/ContactUs?ids[0]=" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // NewsLetter Actions -------------------------------------------------------------------------------
  getNewsLetters({ dispatch, commit }) {
    axios
      .get("Admin/Subscriber")
      .then((res) => {
        commit("setNewsLetters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  deleteNewsLetter({ dispatch }, data) {
    axios
      .delete("Admin/Subscriber?ids=" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // ..................  Team  ...................
  getTeam({ dispatch, commit }, data) {
    axios
      .get("Admin/Team", data)
      .then((res) => {
        commit("setTeam", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Admin/Team", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Admin/Team/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteTeam({ dispatch }, data) {
    axios
      .delete("admin/Team/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Faqs Actions -------------------------------------------------------------------------------
  getFaqs({ dispatch, commit }) {
    axios
      .get("Admin/Faq")
      .then((res) => {
        commit("setFaqs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getFaq({ dispatch, commit }, data) {
    axios
      .get("Admin/Faq/" + data)
      .then((res) => {
        commit("setFaq", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addFaq({ dispatch }, data) {
    axios
      .post("Admin/Faq", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editFaq({ dispatch }, data) {
    axios
      .put("Admin/Faq/" + data.id, data.values)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  deleteFaq({ dispatch }, data) {
    axios
      .delete("Admin/Faq/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
};
